// Mode buckets — the toolbar exposes three logical groups instead of every
// individual digital protocol. Spots keep their granular `mode` field
// (FT8, SSB, RTTY…); the bucket map is consulted only at filter time.
export const ALL_MODE_BUCKETS = ['CW', 'Phone', 'Digi'];

// Maps a granular mode token (matching schema's modeAliases) to the bucket
// it belongs to. Modes not listed (e.g. "unknown") fall outside every
// bucket and are excluded whenever any bucket is selected.
export const MODE_TO_BUCKET = {
  CW:      'CW',
  SSB:     'Phone',
  AM:      'Phone',
  FM:      'Phone',
  RTTY:    'Digi',
  FT8:     'Digi',
  FT4:     'Digi',
  FT2:     'Digi',
  PSK31:   'Digi',
  PSK63:   'Digi',
  JT65:    'Digi',
  JS8:     'Digi',
  WSPR:    'Digi',
  OPERA:   'Digi',
  MFSK:    'Digi',
  DIGITAL: 'Digi',
};

export function bucketForMode(mode) {
  return MODE_TO_BUCKET[mode] || null;
}
